import React, { useEffect, useState } from "react";
import {
  Tabs,
  Input,
  Card,
  Button,
  Divider,
  Spin,
  message,
  Modal,
  Radio,
  Row,
  Col,
} from "antd";
import {
  CaretLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import axios from "axios";
import "../../../config";
import { useParams } from "react-router-dom";
import ProductAdminCard from "./ProductAdminCard";

const { TabPane } = Tabs;
const { Search } = Input;

const ProductAdminListforDisplayImg = () => {
  let { categoryIDQuery, categoryName } = useParams();
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const [products, setProducts] = useState([]);
  const [showProdStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImageID, setSelectedImageID] = useState(null);

  const [currentProductID, setCurrentProductID] = useState(null);

  const [isDealModalVisible, setIsDealModalVisible] = useState(false);
  const [dealPrice, setDealPrice] = useState("");
  const [password, setPassword] = useState("");

  const [isTagModalVisible, setIsTagModalVisible] = useState(false);
  const [tag1, setTag1] = useState("");
  const [tag2, setTag2] = useState("");
  const [tagProductID, setTagProductID] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  // 1. Add state for Trending modal
  const [isTrendingModalVisible, setIsTrendingModalVisible] = useState(false);
  const [trendingProductID, setTrendingProductID] = useState(null);

  // Add Instagram modal state
  const [isInstagramModalVisible, setIsInstagramModalVisible] = useState(false);
  const [instagramPassword, setInstagramPassword] = useState("");

  // Add state for selected Instagram images at the top with other useState hooks:
  const [selectedInstagramImages, setSelectedInstagramImages] = useState([]);

  // ...inside your component, add state for POSTON selection:
  const [postOn, setPostOn] = useState("FANCY");

  useEffect(() => {
    document.title = "JOJ | " + categoryName;
    window.scrollTo(0, 0);
    checkUserActiveStatus();
    getListofProduct();
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === true ||
            response.data.IsEmployee !== true // <-- Only allow if IsEmployee is true
          ) {
            alert("You are not authorized to access this page.");
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.href = "/"; // <-- Redirect to home
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const handleAddToDealClick = (product) => {
    setCurrentProductID(product.ProductID);
    setDealPrice(product.SalesRate); // Auto-fill the deal price with the product's existing price
    setIsDealModalVisible(true);
  };

  const handleImageClick = async (productId) => {
    console.log("Product ID:", productId);
    setCurrentProductID(productId);
    setIsModalVisible(true);
    fetchProductImages(productId);
  };

  const handleConfirmAddToDeal = async () => {
    if (password !== "7979JOJ123") {
      messageApi.open({
        type: "error",
        content: "Invalid password. Please try again.",
      });
      return;
    }

    if (!dealPrice || isNaN(dealPrice) || dealPrice <= 0) {
      messageApi.open({
        type: "error",
        content: "Please enter a valid deal price.",
      });
      return;
    }

    setLoading(true);

    try {
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL +
          "api/LastChanceDeal/AddProductToDeal?ProductID=" +
          currentProductID +
          "&Price=" +
          dealPrice,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
      };

      const response = await axios.request(config);

      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Product successfully added to the deal!",
        });
        setIsDealModalVisible(false);
        setDealPrice("");
        setPassword("");
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to add product to the deal.",
        });
      }
    } catch (error) {
      console.error("Error adding product to the deal:", error);
      messageApi.open({
        type: "error",
        content: "An error occurred. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDealModal = () => {
    setIsDealModalVisible(false);
    setDealPrice("");
    setPassword("");
  };

  const filteredProducts = products.filter(
    (product) =>
      (activeTab === "All" || product.Status === activeTab) &&
      product.ProductName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  async function getListofProduct() {
    setLoading(true);
    let CategoryID = sessionStorage.getItem("CategoryID");
    if (!CategoryID) {
      CategoryID = categoryIDQuery;
    }
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL +
          "api/Product/ListofProductByCategoryforList?CategoryID=" +
          CategoryID,
        headers: {
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          console.log("Product List:", response.data);
          setProducts(response.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } catch (err) {
      setLoading(false);
    }
  }

  const fetchProductImages = async (productId) => {
    try {
      setLoading(true);
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "get",
        url: global.config.APIURL.BaseURL + "api/Product/GetProductImages",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        params: { ProdID: productId },
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        setImages(response.data);
        const currentDisplayImage = response.data.find(
          (img) => img.IsDisplayImage
        );
        setSelectedImageID(currentDisplayImage?.ImageID || null);
      } else {
        message.error("Failed to fetch product images.");
      }
    } catch (error) {
      console.error("Error fetching product images:", error);
      message.error("Error fetching product images.");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDisplayImage = async () => {
    try {
      setLoading(true);
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL +
          "api/Product/SetProductDisplayImage?ProdID=" +
          currentProductID +
          "&DisplayImageID=" +
          selectedImageID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Display image updated successfully.",
        });
        setIsModalVisible(false);
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update display image.",
        });
      }
    } catch (error) {
      console.error("Error updating display image:", error);
      messageApi.open({
        type: "error",
        content: "Error updating display image.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Handler to open Manage Tag modal and prefill values
  const handleManageTagClick = (product) => {
    setTagProductID(product.ProductID);
    setTag1(product.Tag1 || "");
    setTag2(product.Tag2 || "");
    setIsTagModalVisible(true);
  };

  // Handler to save tags
  const handleSaveTag = async () => {
    if (!tagProductID) return;
    setLoading(true);
    const tokenString = localStorage.getItem("token");
    try {
      const config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/Product/SetProductTag",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        data: {
          ProductID: tagProductID,
          Tag1: tag1,
          Tag2: tag2,
        },
      };
      const response = await axios.request(config);
      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Tags updated successfully!",
        });
        setIsTagModalVisible(false);
        // Optionally refresh product list to reflect changes
        getListofProduct();
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to update tags.",
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Error updating tags.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelTagModal = () => {
    setIsTagModalVisible(false);
    setTag1("");
    setTag2("");
    setTagProductID(null);
  };

  // 2. Handler to open Trending modal
  const handleAddToTrendingClick = (product) => {
    setTrendingProductID(product.ProductID);
    setIsTrendingModalVisible(true);
  };

  // 3. Handler to confirm and call API
  const handleConfirmAddToTrending = async () => {
    if (!trendingProductID) return;
    setLoading(true);
    const tokenString = localStorage.getItem("token");
    try {
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL +
          "api/TrendingItems/AddTrendingItem?ProductID=" +
          trendingProductID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
      };
      const response = await axios.request(config);

      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Product added to Trending Items successfully!",
        });
        setIsTrendingModalVisible(false);
        setTrendingProductID(null);
        getListofProduct();
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to add product to Trending Items.",
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Error adding product to Trending Items.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelTrendingModal = () => {
    setIsTrendingModalVisible(false);
    setTrendingProductID(null);
  };

  // Handler to create Instagram post
  const handleCreateInstagramPost = async () => {
    if (instagramPassword !== "JOJ@123@456@JOY") {
      messageApi.open({
        type: "error",
        content: "Invalid password. Please try again.",
      });
      return;
    }
    if (selectedInstagramImages.length === 0) {
      messageApi.open({
        type: "error",
        content: "Please select at least one image.",
      });
      return;
    }
    // Get keywords
    const product = products.find((p) => p.ProductID === currentProductID);
    let keywordsArr = [];
    if (categoryNameFromSession) {
      keywordsArr.push(categoryNameFromSession);
    }
    if (Array.isArray(product?.Keywords) && product.Keywords.length > 0) {
      keywordsArr = keywordsArr.concat(
        product.Keywords.map((kw) => `${kw} ${categoryNameFromSession}`)
      );
    }
    const KeyWords = keywordsArr.join(", ");
    if (!KeyWords.trim()) {
      messageApi.open({
        type: "error",
        content: "No keywords found. Please add keywords before posting.",
      });
      return;
    }
    setLoading(true);
    try {
      // Prepare data for API
      const selectedImgs = images.filter((img) =>
        selectedInstagramImages.includes(img.ImageID)
      );
      const NumberOfFiles = selectedImgs.length;
      const fileFields = {};
      for (let i = 0; i < 10; i++) {
        fileFields[`File${i + 1}`] = selectedImgs[i]?.ImageUrl || "";
      }
      const reqBody = {
        ProductID: currentProductID,
        NumberOfFiles,
        KeyWords,
        ...fileFields,
        Password: instagramPassword,
        POSTON: postOn,
      };
      const tokenString = localStorage.getItem("token");
      const config = {
        method: "post",
        url:
          global.config.APIURL.BaseURL + "api/ProductInstaPost/CreateInstaPost",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        data: reqBody,
      };
      const response = await axios.request(config);
      if (response.status === 200) {
        messageApi.open({
          type: "success",
          content: "Instagram post created successfully!",
        });
        setIsInstagramModalVisible(false);
        setInstagramPassword("");
        setSelectedInstagramImages([]);
      } else {
        messageApi.open({
          type: "error",
          content: "Failed to create Instagram post.",
        });
      }
    } catch (error) {
      messageApi.open({
        type: "error",
        content: "Error creating Instagram post.",
      });
    } finally {
      setLoading(false);
    }
  };

  // Get Category Name from session storage
  const categoryNameFromSession = sessionStorage.getItem("CategoryName");

  return (
    <div style={{ padding: 0 }}>
      {contextHolder}
      <Card>
        {/* Show Category Name as Title */}
        <h2 style={{ marginBottom: 16, color: "#1677ff", fontWeight: 700 }}>
          {categoryNameFromSession || "Category"}
        </h2>
        <Button
          type="primary"
          icon={<CaretLeftOutlined />}
          onClick={() => window.history.back()}
        >
          Back to Category List
        </Button>
        <Divider />

        <Tabs
          defaultActiveKey="All"
          onChange={(key) => setActiveTab(key)}
          style={{ marginBottom: 16 }}
        >
          <TabPane tab={`All (${products.length})`} key="All" />
          {showProdStatus && (
            <>
              <TabPane
                tab={`Available (${
                  products.filter((p) => p.Status === "Available").length
                })`}
                key="Available"
              />
              <TabPane
                tab={`Out of Stock (${
                  products.filter((p) => p.Status === "Out of Stock").length
                })`}
                key="Out of Stock"
              />
            </>
          )}
        </Tabs>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 24,
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          <Search
            placeholder="Search products..."
            onSearch={(value) => setSearchTerm(value)}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ maxWidth: 300 }}
            allowClear
          />
          <Button>Add Default Sorting</Button>
        </div>

        <Spin spinning={loading}>
          {filteredProducts.map((product) => (
            <div key={product.ProductID} style={{ marginBottom: 16 }}>
              <ProductAdminCard
                product={product}
                showProdStatus={showProdStatus}
                onImageClick={handleImageClick}
                onAddToDealClick={() => handleAddToDealClick(product)}
                handleManageTagClick={() => handleManageTagClick(product)}
                onAddToTrendingClick={() => handleAddToTrendingClick(product)}
                onInstaGramPostClick={() => {
                  setCurrentProductID(product.ProductID);
                  setIsInstagramModalVisible(true);
                  setInstagramPassword("");
                  setSelectedInstagramImages([]); // Reset selection when opening modal
                  fetchProductImages(product.ProductID); // Ensure images are loaded for the modal
                }}
              />
            </div>
          ))}
        </Spin>
      </Card>

      {/* Modal for Display Image Selection */}
      <Modal
        title="Select Display Image"
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleSaveDisplayImage}
        confirmLoading={loading}
        okText="Save"
      >
        <div style={{ padding: "16px" }}>
          <Row gutter={[16, 16]}>
            {images.map((image) => (
              <Col xs={24} sm={12} md={8} lg={6} key={image.ImageID}>
                <div
                  style={{
                    border:
                      selectedImageID === image.ImageID
                        ? "2px solid #1890ff"
                        : "1px solid #d9d9d9",
                    borderRadius: "8px",
                    padding: "8px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => setSelectedImageID(image.ImageID)}
                >
                  <img
                    src={image.ImageUrl}
                    alt={image.Name}
                    style={{
                      width: "100%",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "4px",
                      marginBottom: "8px",
                    }}
                  />
                  <span>{image.Name}</span>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Modal>

      {/* Modal for Add Product to Deal */}
      <Modal
        title="Add Product to Deal"
        open={isDealModalVisible}
        onCancel={handleCancelDealModal}
        onOk={handleConfirmAddToDeal}
        confirmLoading={loading}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>
          Please enter the deal price and password to add this product to the
          deal.
        </p>
        <Input
          placeholder="Enter Deal Price"
          type="number"
          value={dealPrice}
          onChange={(e) => setDealPrice(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
        <Input.Password
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>

      {/* Modal for Manage Product Tags */}
      <Modal
        title="Manage Product Tags"
        open={isTagModalVisible}
        onCancel={handleCancelTagModal}
        onOk={handleSaveTag}
        confirmLoading={loading}
        okText="Save"
        cancelText="Cancel"
      >
        <Input
          placeholder="Tag1"
          value={tag1}
          onChange={(e) => setTag1(e.target.value)}
          style={{ marginBottom: 16 }}
        />
        <Input
          placeholder="Tag2"
          value={tag2}
          onChange={(e) => setTag2(e.target.value)}
        />
      </Modal>

      {/* Modal for Trending Items Confirmation */}
      <Modal
        title="Add to Trending Items"
        open={isTrendingModalVisible}
        onOk={handleConfirmAddToTrending}
        onCancel={handleCancelTrendingModal}
        confirmLoading={loading}
        okText="Confirm"
        cancelText="Cancel"
        centered
      >
        <div style={{ textAlign: "center", fontSize: 16 }}>
          <ExclamationCircleOutlined
            style={{ color: "#faad14", fontSize: 32, marginBottom: 12 }}
          />
          <br />
          Are you sure you want to add this product to <b>Trending Items</b>?
        </div>
      </Modal>

      {/* Modal for Create Instagram Post */}
      <Modal
        title="Create Instagram Post"
        open={isInstagramModalVisible}
        onOk={handleCreateInstagramPost}
        onCancel={() => {
          setIsInstagramModalVisible(false);
          setInstagramPassword("");
          setSelectedInstagramImages([]);
          setPostOn("FANCY");
        }}
        confirmLoading={loading}
        okText="Create"
        cancelText="Cancel"
        centered
      >
        <Spin spinning={loading}>
          {/* Radio buttons for POSTON */}
          <Radio.Group
            value={postOn}
            onChange={(e) => setPostOn(e.target.value)}
            style={{ marginBottom: 16 }}
          >
            <Radio.Button value="FANCY">Fancy</Radio.Button>
            <Radio.Button value="RAJPUTI">Rajputi</Radio.Button>
          </Radio.Group>

          <p>
            Please enter the password to create an Instagram post for this
            product.
          </p>
          <Input.Password
            placeholder="Enter Password"
            value={instagramPassword}
            onChange={(e) => setInstagramPassword(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <Input
            placeholder="Enter Keywords (comma separated)"
            value={(() => {
              const product = products.find(
                (p) => p.ProductID === currentProductID
              );
              // Build keywords: category name first, then all keywords with category name
              let keywordsArr = [];
              if (categoryNameFromSession) {
                keywordsArr.push(categoryNameFromSession);
              }
              if (
                Array.isArray(product?.Keywords) &&
                product.Keywords.length > 0
              ) {
                keywordsArr = keywordsArr.concat(
                  product.Keywords.map(
                    (kw) => `${kw} ${categoryNameFromSession}`
                  )
                );
              }
              return keywordsArr.join(", ");
            })()}
            readOnly
            style={{ marginBottom: 8 }}
          />

          {/* Display all images for selection (max 9) */}
          <div style={{ marginBottom: 12 }}>
            <div style={{ marginBottom: 6, fontWeight: 500 }}>
              Select up to 9 images:
            </div>
            <Row gutter={[8, 8]}>
              {images.map((img) => (
                <Col xs={8} sm={6} md={4} key={img.ImageID}>
                  <div
                    style={{
                      border: selectedInstagramImages.includes(img.ImageID)
                        ? "2px solid #1677ff"
                        : "1px solid #d9d9d9",
                      borderRadius: 8,
                      padding: 4,
                      textAlign: "center",
                      cursor: "pointer",
                      position: "relative",
                      background: selectedInstagramImages.includes(img.ImageID)
                        ? "#e6f7ff"
                        : "#fff",
                    }}
                    onClick={() => {
                      if (selectedInstagramImages.includes(img.ImageID)) {
                        setSelectedInstagramImages(
                          selectedInstagramImages.filter(
                            (id) => id !== img.ImageID
                          )
                        );
                      } else if (selectedInstagramImages.length < 9) {
                        setSelectedInstagramImages([
                          ...selectedInstagramImages,
                          img.ImageID,
                        ]);
                      }
                    }}
                  >
                    <img
                      src={img.ImageUrl}
                      alt={img.Name}
                      style={{
                        width: "100%",
                        height: 70,
                        objectFit: "cover",
                        borderRadius: 4,
                        marginBottom: 4,
                        opacity: selectedInstagramImages.includes(img.ImageID)
                          ? 1
                          : 0.7,
                        border: selectedInstagramImages.includes(img.ImageID)
                          ? "2px solid #1677ff"
                          : "1px solid #eee",
                      }}
                    />
                    <div style={{ fontSize: 12 }}>{img.Name}</div>
                    {selectedInstagramImages.includes(img.ImageID) && (
                      <div
                        style={{
                          position: "absolute",
                          top: 4,
                          right: 8,
                          background: "#1677ff",
                          color: "#fff",
                          borderRadius: "50%",
                          width: 20,
                          height: 20,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 14,
                          fontWeight: 700,
                        }}
                      >
                        ✓
                      </div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
            <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
              Selected: {selectedInstagramImages.length} / 9
            </div>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};

export default ProductAdminListforDisplayImg;
